import { render, staticRenderFns } from "./CommandKItemGroupware.vue?vue&type=template&id=d2eefa90&"
import script from "./CommandKItemGroupware.vue?vue&type=script&lang=js&"
export * from "./CommandKItemGroupware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports